import GeneralServices from "./GeneralServices";

import { IGetImportInsuredTemplate, IGetImportInsuredTemplateProps } from "./DocsTemplatesServices-dto";
import { CatchErrorType, IResponseError } from "./dto/response/CommonResponse.dto";

class DocsTemplatesServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;
    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getImportInsuredTemplate = async ({
    loader,
    setLoading,
    isSimulation,
  }: IGetImportInsuredTemplateProps): Promise<IGetImportInsuredTemplate | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `files/download-massive-insureds?isSimulation=${isSimulation}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación de la plantilla de exportación de asegurados."
      );
    }
  };
}

export default new DocsTemplatesServices();
